import Cookies from 'js-cookie'


const TokenKey = 'tokenKey'
const RefreshTokenKey = 'refreshTokenKey'

export function getToken() {
    return Cookies.get(TokenKey)
  }
  
export function setToken(token) {
  return Cookies.set(TokenKey, token, {sameSite: 'None', secure: true})
}

export function getRefreshToken() {
  return Cookies.get(RefreshTokenKey)
}

export function setRefreshToken(refreshToken) {
return Cookies.set(RefreshTokenKey, refreshToken, {sameSite: 'None', secure: true})
}